<app-color-grid-preview [colors]="colors" [showRgbValues]="showRgbValues" [tooltipDisabled]="true"></app-color-grid-preview>
